import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';

let namespace = 'roleAuth_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const roleAuthAc = {
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},	

	GETROLE :()=>(dispatch,getState)=>{
		// 这里暂时设置为获取50条(用户角色数量应该很长一段时间都不会超过这个数)，因为如果不设置后端默认为10
		let value ={class_name:'用户角色', pageSize: 50, currentPage: 1}
		let Axios = AxiosServer();

		 Axios.post('/parameters/all',value).then((res)=>{	
		 
			dispatch({type: namespace+'forcedUpdate', payload: {roleList:res.data.data, dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
		}).catch((err)=>{
			console.log('err:',err);
		});	
		
	},	

	GETROLEAUTH :(value)=>(dispatch,getState)=>{		
		let Axios = AxiosServer();

		return Axios.post('/menuAuth/findAll',value).then((res)=>{	
			
			if (res.data.status == true && res.data.count >0 ){	
				//如果成功，将res.data.data中的menu解构出来，取checkedKeys赋值。
				let resdata= res.data.data[0];					
				const {menu} =resdata;				
				if (!menu || !menu.checkedKeys){
					message.warning('权限配置不正确，请联系管理员或重新初始化');
					dispatch({type: namespace+'forcedUpdate', payload: {initRole:true, dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				}
				dispatch({type: namespace+'forcedUpdate', payload: {roleAuth:resdata.menu.checkedKeys,hasTreeKeys:resdata.menu, dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				return '获取成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '获取失败'
			}
			
		}).catch((err)=>{
			message.error('getRoleAuth err: ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '获取错误'
			console.log('err:',err);
		});	
		
	},

	
	UPDATEROLEAUTH:(value)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错		
		let Axios = AxiosServer();
		return  Axios.post('/menuAuth/updateRoleAuth',value).then((res)=>{					
		    if (res.data.status ==true){	
				
				//如果成功，更新roleAuth
				return '更新成功'
			}else{
				//如果失败，返回消息给前台
				return '更新失败'
			}			
		   
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return err.message 
		})
	},	

	GET:(value)=>(dispatch,getState)=>{
		
		let store =getState().orderPendingRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}
		
		let Axios = AxiosServer();
		return Axios.post('/order/findAll',dataFetchProps).then((res)=>{	
							
			if (res.data.status == true){				
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
		})
	},	
	
	
	
	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let id = parseInt(value.id);	
		let store = getState();
		let currentStore =store.orderPendingRd	
		let dataFetchProps =currentStore.dataFetchProps		
		let {include} =dataFetchProps		
		
		let Axios = AxiosServer();
		return  Axios.post('/order/updateWithInclude',{id,value,include}).then((res)=>{		
		   
			dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});		
		//   dispatch(userlist_GET({order:[['id']]}));
		   return '更新成功'
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	
	UPDATEREMOVE:(value,selectedRowIndex)=> (dispatch,getState)=>{	
		
		let id = parseInt(value.id);	
		
		let store = getState();
		let currentStore =store.orderPendingRd	
		let dataFetchProps =currentStore.dataFetchProps		
		let {include} =dataFetchProps		
		let Axios = AxiosServer();			
		return  Axios.post('/order/updateWithInclude',{id,value,include}).then((res)=>{		
			
			dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});
			dispatch({type:namespace+'RemoveDataByIndex', payload: {selectedRowIndex}});				
		
		   return '更新成功'
		}).catch((err)=>{
			dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
		
	
	}
	

}


export {roleAuthAc};